import * as React from 'react';
import { SaveDraftContainer } from '../SaveDraft';
import * as styles from './NeedIdentificationDesktop.css';

export const NeedIdentificationDesktop = () => {
  return (
    <div className={styles['wrapper']}>
      <SaveDraftContainer />
    </div>
  );
};
